import * as Connector from 'shared/connectors/notificationConnector';
import { NOTIFICATION } from 'store/types';

const init = () => ({
  type: NOTIFICATION.GET_SINGLE_NOTIFICATION_INIT,
});

export const success = data => ({
  type: NOTIFICATION.GET_SINGLE_NOTIFICATION_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: NOTIFICATION.GET_SINGLE_NOTIFICATION_FAILURE,
});

const getSingleNotification = uuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getSingleNotification(uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getSingleNotification;
